<template>
  <div>
    <lte-table
      :hdBackground="hdBackground"
      :data="gridBatchJobDataList"
      :columns="gridColumns"
      search_filter="left-search"
      @actions="crudActions"
      :actions="actions"
      :useCheckBox="useCheckBox"
      @selectedItems="selectedItems"
      :useFilter="useFilter"
      :boxStyle="boxStyle"
    ></lte-table>
    <lte-modal
      v-show="isModalVisible"
      @onConfirm="onConfirm"
      @close="closeModal"
      v-for="obj in objModal"
      :key="obj.id"
      :item="obj"
    ></lte-modal>
       <div class="box-footer clearfix" style="display:contents;">
          <paginator :item="paginatorItem" @onpaginate="onPagination" />
        </div>
    <loading :active.sync="isLoading" :can-cancel="false" color="#1E90FF"></loading>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { LTEActionTypeEnum } from '@/components/LTEEnum'
import LTETable from "@/components/LTETable.vue";
import LTEModal from "@/components/LTEModal.vue";
import Paginator from "@/components/Paginator.vue";
import Loading from "vue-loading-overlay";
import utils from "@/lib/utils";
import i18n from "../../lang";
import BatchStatusEnum from "@/enum/batchStatusEnum";
import BatchIntervalEnum from "@/enum/batchIntervalEnum";

export default {
  name: "BatchJobShowList",
  data() {
    return {
      gridBatchJobDataList: [],
      actions: ["common.modify"], // "common.modify", "common.delete", common.printPdf
      gridColumns: [
        { text: "common.nonumber", isHidden: true },
        { text: "batch_job.job_name", isHidden: true },
        { text: "batch_job.job_description", isHidden: true },
        { text: "batch_job.job_status", isHidden: true },
        { text: "batch_job.interval", isHidden: true },
        { text: "batch_job.start_date", isHidden: true },
        { text: "batch_job.end_date", isHidden: true },
        { text: "batch_job.user_updated", isHidden: true }
      ],
      boxStyle: false,
      useFilter: false,
        paginatorItem: {
        commit_function: "GET_BATCH_JOB_LIST"
      },

      hdBackground:
        "background-color: #4b646f;color:white;border:1px solid white;", //00a65a
      isLoading: false,

      columnsReceipt: {
        data_list: [],
        itemType: 1,
        showLabel: false,
        modifyFromPosition: "margin-top:-300px",
        cssClassSm1: "col-md-1",
        cssClassSm2: "col-sm-1",
        showAddNew: false
      },

      useCheckBox: false,
      used_wallet: false,
       isModalVisible: false,
      objModal: [
        {
          title    : "common.delete_modal.title",
          body     : "common.delete_modal.content",
          buttonNo : "common.delete_modal.btnNo",
          buttonYes: "common.delete_modal.btnYes",
          styleType: "default"
        }
      ],
    };
  },
  watch: {
    GET_BATCH_JOB_LIST_DATA: function() {
      this.gridBatchJobDataList=[]
      this.GET_BATCH_JOB_LIST_DATA.forEach((batchJob, i) => {
        let nonumber =
          i + 1 + (this.PAGINATION.page - 1) * this.PAGINATION.size;

        let job_name = batchJob.job_name;
        let job_description = batchJob.job_description;
        let job_status_name = this.getBatchStatusName(batchJob.job_status);
        let interval_name = this.getBatchIntervalName(batchJob.interval);
        let start_date = batchJob.start_date;
        let end_date = batchJob.end_date;

        let id = batchJob.id;

        let user_updated = this.getFullNameUserUpdate(
          batchJob.user_updated_first_name,
          batchJob.user_updated_last_name
        );

        let data = {
          "common.nonumber": nonumber,
          "batch_job.job_name": job_name,
          "batch_job.job_description": job_description,
          "batch_job.job_status": job_status_name,
          "batch_job.interval": interval_name,
          "batch_job.user_updated": user_updated,
          "batch_job.start_date": utils.formatSqlDate(start_date, null, "DD/MM/YYYY hh:mm:ss", ""),
          "batch_job.end_date": utils.formatSqlDate(end_date, null, "DD/MM/YYYY hh:mm:ss", ""),
          id: id
        };
        this.gridBatchJobDataList.push(data);
      });

      return this.gridBatchJobDataList;
    },
    GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA: function() {
      if (!utils.isNull(this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data)) {
        let newGridColumns = [];
        const viewedColumnsKey = Object.keys(
          this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data.viewed_columns
        );
        const viewedColumns = this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA.data
          .viewed_columns;
        for (
          let j = 0, sizeOrigin = this.gridColumns.length;
          j < sizeOrigin;
          j++
        ) {
          for (let i = 0, size = viewedColumnsKey.length; i < size; i++) {
            if (this.gridColumns[j].text == viewedColumnsKey[i]) {
              let viewdColumnObject = {};
              viewdColumnObject.text = viewedColumnsKey[i];
              viewdColumnObject.isHidden = viewedColumns[viewedColumnsKey[i]];
              newGridColumns.push(viewdColumnObject);
              break;
            }
          }
        }
        this.gridColumns = newGridColumns;
        this.columnsReceipt.data_list = this.gridColumns;
      }
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "PAGINATION",
      "PAGINATOR",
      "PAGE_ARROW",
      "GET_RECEIPT_DATA",
      "GET_BATCH_JOB_LIST_DATA",
      "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG_DATA"
    ])
  },
  methods: {
    onBatchJobShowList: function () {
      const data = {
        params: {
          page: 1
        }
      };

      this.GET_BATCH_JOB_LIST(data);
    },
    getFullNameUserCreate(firstname, lastname){
      return utils.getFullName(firstname, lastname, i18n.locale);
    },
    getFullNameUserUpdate(firstname, lastname){
      return utils.getFullName(firstname, lastname, i18n.locale);
    },
    getBatchStatusName: function(status) {
      if (status == BatchStatusEnum.DEACTIVATED) {
        return this.$t("batch_status.Deactivated")
      } else if (status == BatchStatusEnum.ACTIVATED) {
        return this.$t("batch_status.Activated")
      }
      return ""
    },
    getBatchIntervalName: function(type) {
      if (type == BatchIntervalEnum.IMMEDIATELY) {
        return this.$t("batch_interval.Immediately")
      } else if (type == BatchIntervalEnum.EVERY_FIVE_MINUTES) {
        return this.$t("batch_interval.Every_Five_Minutes")
      } else if (type == BatchIntervalEnum.EVERY_HOUR) {
        return this.$t("batch_interval.Every_Hour")
      } else if (type == BatchIntervalEnum.DAILY) {
        return this.$t("batch_interval.Daily")
      } else if (type == BatchIntervalEnum.WEEKLY) {
        return this.$t("batch_interval.Weekly")
      }
      return ""
    },
    selectedItems: function(list_receipt_id) {
      // this.list_receipt_id = list_receipt_id;
    },
    getFullNameByLanguage(first_name, last_name) {
      if (data != null) {
        return utils.getFullName(first_name, last_name, i18n.locale);
      }
      return "";
    },
    onSearchReceipt: function(fromDate, toDate, user_created) {
      const data = {
        params: {
          page: 1,
          from_date: utils.formatSqlDate(fromDate, null, "YYYY-MM-DD"),
          to_date: toDate,
          user_created: user_created
        }
      };
      this.isLoading = true;
      this.GET_BATCH_JOB_LIST(data).then(
        function() {
          this.isLoading = false;
        }.bind(this)
      ).catch(
        function(error) {
          this.isLoading = false;
              this.ON_SHOW_TOAST({
                message: error,
                styleType: "danger"
              });
            }.bind(this)
          );
    },
    saveCustomizeTable: function(tables) {
    },
    crudActions: function(recordData, actionsType, isModalVisible) {
      if (actionsType == LTEActionTypeEnum.MODIFY) {
        this.$router.push({
          name: "BatchJobAdd",
          params: {
            id: recordData.id
          }
        });
      }
    },
    onConfirm: function() {
      this.isModalVisible = false;
      this.DELETE_RECEIPT(this.originalRecordData)
        .then(
          function() {
            let currentPage = this.PAGINATION.page;
            let totalPage = this.PAGINATOR.length;
            let page =
              currentPage >= totalPage && this.gridCustomerDataList.length == 1
                ? totalPage - 1
                : currentPage;
            const data = {
              params: {
                page: page
              }
            };
            this.GET_BATCH_JOB_LIST(data);
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    onPrevPagination: function() {
      const data = {
        url: this.PAGE_ARROW.prev,
        commit_funtion: "GET_BATCH_JOB_LIST"
      };
      this.PAGINATION_PREV_PAGE(data);
    },
    onNextPagination: function() {
      const data = {
        url: this.PAGE_ARROW.next,
        commit_funtion: "GET_BATCH_JOB_LIST"
      };
      this.PAGINATION_NEXT_PAGE(data);
    },
    onPagination: function(data) {
      this.GET_BATCH_JOB_LIST(data);
    },
    closeModal() {
      this.isModalVisible = false;
    },

    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "PAGINATION_PREV_PAGE",
      "PAGINATION_NEXT_PAGE",
      "GET_BATCH_JOB_LIST",
      "DELETE_RECEIPT",
      // "SAVE_CUSTOMIZE_TABLE_PERSONAL_CONFIG",
      "GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG"
    ])
  },
  mounted() {
    const data = {
      params: {
        page: 1
      }
    };

    this.GET_BATCH_JOB_LIST(data);
    this.columnsReceipt.data_list = this.gridColumns;
    const filter = {
      params: {
        tablename: "receiptlist"
      }
    };
    this.GET_CUSTOMIZE_TABLE_PERSONAL_CONFIG(filter);
  },

  components: {
    "lte-table": LTETable,
    "lte-modal": LTEModal,
    paginator: Paginator,
    loading: Loading,
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/Project/BatchJobShowList.vue